module.exports = __webpack_public_path__ + "static/img/service_head_01_zh.e9f75b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_head_01_zh.png
// module id = Wyd2
// module chunks = 34